var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"slider-wrapper"},[_c('div',{class:['slider', _vm.type],style:({height: (_vm.value + "%")})}),(_vm.threshold > 0)?_c('div',{staticClass:"threshold",style:({top: ((100 - _vm.threshold) + "%")})}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }